"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconHydrogenStorageUnderground = function IconHydrogenStorageUnderground(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M27.32 10.65C27.32 7.219 29.395 2 32 2c2.6 0 5 5.381 5 8.65 0 2.364-1.79 4.67-4 5.225V18h9v2H22v3.05c5.053.501 9 4.765 9 9.95 0 5.523-4.477 10-10 10s-10-4.477-10-10c0-5.185 3.947-9.449 9-9.95V20H6v-2h25v-2.128c-2.126-.554-3.68-2.82-3.68-5.222m7.68 0c0 1.654-1.515 3.35-3 3.35-1.403 0-2.68-1.603-2.68-3.35C29.32 8.235 31.004 4 32 4c1.054 0 3 4.363 3 6.65M34.5 26a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m6 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M9 29.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21 25a8 8 0 1 1 0 16 8 8 0 0 1 0-16m1.22 3v6.22h-1.13v-2.73h-2.95v2.73H17V28h1.14v2.41h2.95V28zm.9 7.78 1.16-1 .021-.02c.204-.183.409-.368.409-.61a.28.28 0 0 0-.31-.29.34.34 0 0 0-.36.38h-1a1.21 1.21 0 0 1 1.39-1.31c.84 0 1.33.42 1.33 1.09a1.48 1.48 0 0 1-.67 1.17l-.61.51h1.32v.91h-2.68z",
    clipRule: "evenodd"
  })));
};

export { IconHydrogenStorageUnderground, IconHydrogenStorageUnderground as default };
